import NextImage from 'next/image';
import { DEFAULT_IMAGE } from 'src/constants/config';
import { srcFromCDN } from 'src/utils/files';
import { SITE_MAX_WIDTH } from 'src/constants/ui';

interface Props {
  src: string;
  alt: string;
  objectFit?: 'contain' | 'cover' | 'fill' | 'none' | 'scale-down';
  priority?: boolean;
  columns?: number;
  width?: number;
  onError?: (event: React.SyntheticEvent<HTMLImageElement, Event>) => void;
}

function ImageWithFallback({
  src,
  alt,
  objectFit = 'cover',
  priority = false,
  columns = 1,
  width = SITE_MAX_WIDTH,
  onError,
}: Props) {
  let cdnSrc = src;
  if (!src || src === 'null' || src === '' || !src.includes('http')) {
    cdnSrc = DEFAULT_IMAGE;
  }
  cdnSrc = srcFromCDN(src, width, 'transform', columns);

  let url;
  try {
    url = new URL(cdnSrc);
  } catch (error) {
    console.error('error making URL', error);
  }

  const imageStyle: React.CSSProperties = { objectFit };

  return (
    <NextImage
      src={cdnSrc}
      alt={alt}
      draggable="false"
      style={imageStyle}
      priority={priority}
      onError={onError}
      fill
    />
  );
}

export default ImageWithFallback;
